import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Treatments from "@/pages/Treatments";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Appointment from "@/pages/Appointment";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

const pageTransition = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -16 },
  transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] }
};

function PublicLayout({ children }) {
  return (
    <>
      <Navbar/>
      <motion.div {...pageTransition}>{children}</motion.div>
      <Footer/>
      <FloatingActions/>
    </>
  );
}

function AnimatedRoutes() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <AnimatePresence mode="wait">
      <Routes location={loc} key={loc.pathname}>
        <Route path="/admin/login" element={<AdminLogin/>}/>
        <Route path="/admin" element={<AdminDashboard/>}/>
        <Route path="/" element={<PublicLayout><Home/></PublicLayout>}/>
        <Route path="/about" element={<PublicLayout><About/></PublicLayout>}/>
        <Route path="/treatments" element={<PublicLayout><Treatments/></PublicLayout>}/>
        <Route path="/gallery" element={<PublicLayout><Gallery/></PublicLayout>}/>
        <Route path="/blog" element={<PublicLayout><Blog/></PublicLayout>}/>
        <Route path="/blog/:slug" element={<PublicLayout><BlogDetail/></PublicLayout>}/>
        <Route path="/contact" element={<PublicLayout><Contact/></PublicLayout>}/>
        <Route path="/appointment" element={<PublicLayout><Appointment/></PublicLayout>}/>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AnimatedRoutes/>
        <Toaster position="top-right" richColors/>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
